import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { TokenStore } from 'src/keycloak/jwt/TokenStore'
import AccessDenied from './AccessDenied'
import { SidafComponents } from './utils/SidafComponentsIndex'
import NotFound from './NotFound'
import {
  PATH_ROLES,
  PATH_TO_ERROR,
  PATH_TO_FO_ANAG_ISCRIZIONE_ORDINE_VISUALIZZA,
  PATH_TO_FO_COOKIE,
  PATH_TO_FO_DETTAGLIO_EVENTO_CATALOGO,
  PATH_TO_FO_ELENCO_EVENTI_CATALOGO,
  PATH_TO_FO_FEEDBACK_ACCESSIBILITA,
  PATH_TO_FO_PRIVACY,
  PATH_TO_HOME,
  PATH_TO_RICERCA_ALBO_UNICO,
  PATH_TO_RISULTATI_RICERCA_ALBO_UNICO,
} from './utils/RoutesConstants'
import IscrizioneOrdine from 'src/frontend/app/pages/iscrizioneAlbo/IscrizioneOrdine'
import RicercaIscrittiAlboUnico from 'src/frontend/app/pages/RicercaIscrittiAlboUnico'
import Home from 'src/frontend/app/pages/Home'
import RisultatiRicercaAlboUnico from 'src/frontend/app/pages/ricercaAlboUnico/RisultatiRicercaAlboUnico'
import GenericError from 'src/errorBoundary/GenericError'
import { ErrorStore } from 'src/errorBoundary/ErrorStore'
import moment from 'moment'
import { homeComponent } from 'src/utilities/utility'
import ElencoEventiCatalogo from 'src/backoffice/app/pages/formazione/ElencoEventiCatalogo'
import DettaglioEventoCatalogo from 'src/backoffice/app/pages/formazione/DettaglioEventoCatalogo'
import SidafCookieBar from './utils/SidafCookieBar'
import Cookie from 'src/frontend/app/pages/Cookie'
import Privacy from 'src/frontend/app/pages/Privacy'
import GenericModal from 'src/frontend/app/components/GenericModal'
import FeedbackAccessibilita from 'src/frontend/app/pages/FeedbackAccessibilita'

class AppRouter extends React.Component {
  modalTitle = 'ATTENZIONE!'
  modalGDPRTitle = 'INFORMAZIONI IMPORTANTI'
  modalODAFTitle = 'Novità SIDAF: Nuova Gestione Proroghe e Ripartizione Multipla CFP'

  componentDidMount() {
    let showModalSessionStorage = window.sessionStorage.getItem('showModal')

    if (showModalSessionStorage == null) {
      this.setState({ modalOpen: true, modalGDPROpen: false, modalODAFOpen: false })
    } else {
      this.setState({ modalOpen: false, modalGDPROpen: false, modalODAFOpen: false })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    // Verifica se il profilo corrente è cambiato
    // Questo è necessario perché l'utente potrebbe avere più profili (es: iscritto + operatore)
    try {
      const tokenStore = TokenStore.getInstance()
      const isCurrentIscrittoOrdine = tokenStore.isCurrentAccountIscrittoOrdine()
      const isCurrentAuthenticated = tokenStore.isCurrentAccountAuthenticated()
      const currentAccount = tokenStore.getCurrentAccount()
      const currentKeys = Object.keys(currentAccount.accounts)[0]
      const currentSpecificGroup = currentAccount.accounts[currentKeys].specificGroup

      // Recupera l'ultimo profilo visualizzato dal sessionStorage
      const lastProfileViewed = window.sessionStorage.getItem('lastProfileViewedForGDPR')

      // Se il profilo è cambiato, resettiamo la visualizzazione del modal GDPR per questo profilo
      const profileHasChanged = lastProfileViewed !== currentSpecificGroup

      // Se il profilo corrente è iscritto all'ordine o è solo autenticato (GROUP_AUTHENTICATED), chiudi il modal GDPR
      if (isCurrentIscrittoOrdine || isCurrentAuthenticated) {
        if (this.state?.modalGDPROpen) {
          this.setState({ modalGDPROpen: false })
        }
        // Salva il profilo corrente per il prossimo cambio
        window.sessionStorage.setItem('lastProfileViewedForGDPR', currentSpecificGroup)
      }
      // Se il profilo corrente NON è iscritto all'ordine E NON è solo autenticato:
      // - Se il profilo è cambiato: mostra il modal GDPR
      // - Se il primo modal è aperto: non fare nulla
      // - Se entrambi i modal sono chiusi: mostra il modal GDPR
      else if (!isCurrentIscrittoOrdine && !isCurrentAuthenticated) {
        // Se è un cambio di profilo operatore, resettiamo la visualizzazione
        if (profileHasChanged) {
          window.sessionStorage.removeItem('showModalGDPRForCurrentProfile')
        }

        const showModalGDPRForCurrentProfile = window.sessionStorage.getItem('showModalGDPRForCurrentProfile')

        // Se il primo modal è ancora aperto, non fare nulla
        if (this.state?.modalOpen) {
          return
        }

        // Se il profilo è cambiato e non abbiamo ancora mostrato il modal per questo profilo
        if (profileHasChanged && showModalGDPRForCurrentProfile == null && !this.state?.modalGDPROpen) {
          this.setState({ modalGDPROpen: true })
          window.sessionStorage.setItem('showModalGDPRForCurrentProfile', 'true')
        }

        // Salva il profilo corrente per il prossimo cambio
        window.sessionStorage.setItem('lastProfileViewedForGDPR', currentSpecificGroup)
      }
    } catch (e) {
      console.error('Errore nel controllo GDPR modal nel componentDidUpdate:', e)
    }
  }

  closeModal = () => {
    let showModalSessionStorage = true
    this.setState({ modalOpen: false })
    window.sessionStorage.setItem('showModal', showModalSessionStorage + '')
    // Controlla se deve aprire il secondo modal GDPR
    this.checkAndOpenGDPRModal()
  }

  closeGDPRModal = () => {
    this.setState({ modalGDPROpen: false }, () => {
      window.sessionStorage.setItem('showModalGDPRForCurrentProfile', 'true')
      // Controlla se deve aprire il  modal della mev ripartizioni
      this.checkAndOpenODAFModal()
    })
  }

  closeODAFModal = () => {
    this.setState({ modalODAFOpen: false })

    window.sessionStorage.setItem('showModalODAFForCurrentProfile', 'true')
  }

  checkAndOpenGDPRModal = () => {
    // Verifica se il profilo corrente NON è iscritto all'ordine e NON è solo autenticato
    // Il modal deve uscire per tutti i tipi di operatori TRANNE:
    // - Gli iscritti all'ordine (profilo corrente)
    // - I soli autenticati (GROUP_AUTHENTICATED)
    try {
      const tokenStore = TokenStore.getInstance()
      const isCurrentNonIscrittoOrdine = !tokenStore.isCurrentAccountIscrittoOrdine()
      const isCurrentAuthenticated = tokenStore.isCurrentAccountAuthenticated()
      const showModalGDPRSessionStorage = window.sessionStorage.getItem('showModalGDPR')

      if (isCurrentNonIscrittoOrdine && !isCurrentAuthenticated && showModalGDPRSessionStorage == null) {
        this.setState({ modalGDPROpen: true })
      }
    } catch (e) {
      console.error('Errore nel controllo GDPR modal:', e)
    }
  }

  checkAndOpenODAFModal = () => {
    try {
      const tokenStore = TokenStore.getInstance()

      const isODAF = tokenStore.isCurrentAccountODAF()

      const alreadyShown = window.sessionStorage.getItem('showModalODAFForCurrentProfile')

      if (isODAF && !alreadyShown) {
        this.setState({ modalODAFOpen: true })
      }
    } catch (e) {
      console.error('Errore check ODAF modal:', e)
    }
  }

  render() {
    /**
     * Controlla se ci sono degli errori, allora rimanda alla pagina di errore
     */
    if (ErrorStore.getInstance().getMessageError()) {
      ErrorStore.getInstance().addError({
        title_error: ErrorStore.getInstance().getErrorTitle(),
        message_error: ErrorStore.getInstance().getMessageError(),
        back_url: ErrorStore.getInstance().getBackUrl(),
        time: moment().format('DD/MM/YYYY HH:mm:ss'),
      })
      return <GenericError></GenericError>
    } else if (
      TokenStore.getInstance().getKeycloak() &&
      TokenStore.getInstance().getKeycloak() !== '' &&
      TokenStore.getInstance().getKeycloak().authenticated
    ) {
      const homeComp = homeComponent()
      /**
       * Costruisco la lista delle route dinamicamente.
       * Nell'array ci saranno i percorsi negati e quelli consentiti con il relativo componente.
       */
      let routes = []
      PATH_ROLES.forEach((roleList, path) => {
        if (!TokenStore.getInstance().currentAccountHasRolesOR(roleList)) {
          routes.push(<Route key={path} path={path} component={AccessDenied} />)
        } else if (path === PATH_TO_FO_ANAG_ISCRIZIONE_ORDINE_VISUALIZZA) {
          routes.push(<Route key={path} exact path={path} render={(props) => <IscrizioneOrdine {...props} isVisualizza={true} />} />)
        } else {
          routes.push(<Route exact key={path} path={path} component={SidafComponents[path]} />)
        }
      })

      /**
       * Costruisco il router sulla base delle routes precedentemente calcolate per l'utente corrente.
       */
      let router = (
        <Router>
          <Switch>
            <Route exact path={'/'} component={homeComp} />
            {routes.map((route) => route)}
            <Route path={'/*'} component={NotFound} />
          </Switch>
          <SidafCookieBar />
          <GenericModal
            modalOpen={this.state?.modalOpen}
            closeButton={this.closeModal}
            title={this.modalTitle}
            size={'lg'}
            centered
            text={
              <div>
                <p>
                  Si comunica che, a partire dal 16 settembre 2026 e sino al 30 novembre 2026, accedendo alla pagina dedicata nell’area riservata del SIDAF ({''}
                  <a rel="noreferrer" href="https://www.sidafonline.it">
                   www.sidafonline.it
                  </a>
                  ), sarà possibile, per l’Iscritto in possesso della polizza RC Professionale XL INSURANCE COMPANY SE n. IT00024030EO20A in corso di validità,
                  effettuare il rinnovo per la successiva annualità 2026 – 2027, con il mantenimento della continuità assicurativa. L’adesione avrà comunque
                  decorrenza dalle ore 00:00 del 15 ottobre 2026.
                </p>
                <br></br>
                <p>
                  Per maggiori informazioni sulla polizza si prega di consultare la circolare n.29/2026{' '}
                  <a
                    rel="noreferrer"
                    href="https://www.conaf.it/polizza-collettiva-ad-adesione-per-la-copertura-dei-rischi-professionali-contratta-dal-conaf-con-la-societa-xl-insurance-company-se-per-il-periodo-14-10-2026-14-10-2027-avvio-delle-proposte/"
                  >
                    www.conaf.it/polizza-collettiva-ad-adesione-per-la-copertura-dei-rischi-professionali-contratta-dal-conaf-con-la-societa-xl-insurance-company-se-per-il-periodo-14-10-2026-14-10-2027-avvio-delle-proposte/
                  </a>
                </p>
                <br></br>
                <p>
                  Il Servizio di richiesta, rinnovo e gestione dei dispositivi di firma elettronica e il servizio di assegnazione/cancellazione delle caselle
                  e-mail PEC è momentaneamente accessibile all'indirizzo{' '}
                  <a href="https://www.conafonline.it">
                    www.conafonline.it
                  </a>
                  .
                </p>
                <br></br>
                <p>
                  Maggiori informazioni circa l'utilizzo della piattaforma SIDAF sono reperibili nell'area circolari del portale istituzionale{' '}
                  <a href="https://www.conafonline.it">
                    www.conafonline.it
                  </a>{' '}
                  ed in particolare si invita a prendere visione della circolare relativa all'utilizzo della piattaforma di ticketing “SAM” al seguente link:{' '}
                  <a href="https://www.conaf.it/circolare-n-37-del-27-10-2023/">
                    www.conaf.it/circolare-n-37-del-27-10-2023
                  </a>
                  .
                </p>
                <br></br>
                <p>
                  Si segnala inoltre che la piattaforma è in continua evoluzione con il completamento e l'implementazione di funzioni non ancora disponibili.
                </p>
              </div>
            }
          />
          <GenericModal
            modalOpen={this.state?.modalGDPROpen}
            closeButton={this.closeGDPRModal}
            title={this.modalGDPRTitle}
            size={'lg'}
            centered
            text={
              <div>
                <p>
                  Il Garante per la Protezione dei Dati Personali ha dichiarato l'illiceità del trattamento degli indirizzi PEC rinvenibili in registri o
                  elenchi pubblicati sui siti degli Ordini professionali al di fuori delle specifiche finalità sottese alla loro pubblicazione - e-mail
                  promozionali - senza il previo consenso informato dell'interessato e che l'illiceità non viene meno per il solo fatto che nelle e-mail
                  indesiderate inviate sia presente un link per la cancellazione dalla mailing list.
                </p>
                <p>
                  <strong>Provvedimento n. 7810723 del 1° Febbraio 2018</strong>
                </p>
              </div>
            }
          />
          <GenericModal
            modalOpen={this.state?.modalODAFOpen}
            closeButton={this.closeODAFModal}
            title={this.modalODAFTitle}
            size={'lg'}
            centered
            text={
              <div className="px-2">
                <p>
                  Sono disponibili le nuove funzionalità dedicate agli Operatori dell'Ordine, accessibili dal percorso:
                  <br />
                  <strong>Formazione → Gestione proroghe</strong>
                  <br />
                  (sezioni <em>Concessione proroghe</em> e <em>Riepilogo ripartizioni</em>).
                </p>

                <hr />

                <h6 className="fw-bold mt-3">Principali novità</h6>

                <p>
                  <strong>Proroghe multiple e simultanee</strong>
                  <br />È possibile inserire più proroghe per il medesimo iscritto su trienni differenti, definendo liberamente le date di inizio (anche
                  retroattive) e di fine.
                </p>

                <p>
                  <strong>Modifica e cancellazione delle proroghe</strong>
                  <br />
                  Le proroghe possono essere modificate o eliminate fino alla chiusura del relativo triennio.
                </p>

                <p>
                  <strong>Chiusura automatica tramite certificato</strong>
                  <br />
                  L'approvazione del certificato di regolarità formativa determina la chiusura definitiva delle proroghe attive sul triennio interessato,
                  impostandone la data di fine alla data di decorrenza del certificato.
                </p>

                <p>
                  <strong>Registro dei movimenti</strong>
                  <br />
                  La sezione <em>Riepilogo ripartizioni</em> mette a disposizione una vista dettagliata di tutti gli spostamenti dei CFP effettuati dal sistema.
                </p>

                <hr />

                <h6 className="fw-bold mt-3">Nuova gestione delle ripartizioni CFP</h6>

                <p>
                  Le precedenti ripartizioni manuali sono state dismesse. Il sistema provvede automaticamente alla compensazione dei CFP in tempo reale al
                  momento dell'assegnazione, sanando eventuali debiti formativi secondo un criterio cronologico, dal triennio più remoto a quello più recente.
                </p>

                <div className="alert alert-light border mt-3 mb-0">Per ulteriori dettagli operativi si invita a consultare il manuale utente.</div>
              </div>
            }
          />
        </Router>
      )
      return router
    } else {
      let router = (
        <Router>
          <Switch>
            <Route exact path={PATH_TO_HOME} component={Home} />
            <Route path={PATH_TO_RICERCA_ALBO_UNICO} component={RicercaIscrittiAlboUnico} />
            <Route path={PATH_TO_FO_COOKIE} component={Cookie} />
            <Route path={PATH_TO_FO_PRIVACY} component={Privacy} />
            <Route path={PATH_TO_FO_FEEDBACK_ACCESSIBILITA} component={FeedbackAccessibilita} />
            <Route path={PATH_TO_RISULTATI_RICERCA_ALBO_UNICO} component={RisultatiRicercaAlboUnico} />
            <Route path={PATH_TO_FO_ELENCO_EVENTI_CATALOGO} component={ElencoEventiCatalogo} />
            <Route path={PATH_TO_FO_DETTAGLIO_EVENTO_CATALOGO} component={DettaglioEventoCatalogo} />
            <Route path={PATH_TO_ERROR} component={GenericError} />
            <Route path={'/*'} component={NotFound} />
          </Switch>
          <SidafCookieBar />
        </Router>
      )

      return router
    }
  }
}

export default AppRouter
